var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6251 5.84445V3.95833H2.37508V5.84408L9.5001 9.40694L16.6251 5.84445ZM16.6251 7.61467L9.50006 11.1772L2.37508 7.61433V15.0417H16.6251V7.61467ZM2.37508 2.375H16.6251C17.4995 2.375 18.2084 3.08388 18.2084 3.95833V15.0417C18.2084 15.9161 17.4995 16.625 16.6251 16.625H2.37508C1.50063 16.625 0.791748 15.9161 0.791748 15.0417V3.95833C0.791748 3.08388 1.50063 2.375 2.37508 2.375Z",
    fill: "#8139d0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.da9f8c4b1427b2065b27857dfa676a77.svg";
export { ForwardRef as ReactComponent };